const DATA = {
  GBP: {
    symbol: '£',
  },
  USD: {
    symbol: '$',
  },
  EUR: {
    symbol: '€',
  },
}

const symbol = (currency) => DATA[currency ? currency.toUpperCase() : ''].symbol
const amount = (price) => {
  const isNegative = price < 0
  const absPrice = Math.abs(price)
  const divided = absPrice / 100
  const pounds = Math.floor(divided)
  let pence = Math.round((divided - pounds) * 100)
  while(`${pence}`.length < 2) {
    pence = '0' + pence
  }
  return [
    `${isNegative ? '-' : ''}${pounds}`,
    pence,
  ].join('.')
}
const title = (currency, price) => `${symbol(currency)}${amount(price)}`

module.exports = {
  symbol,
  amount,
  title,
}